var React = require('react');

function IconPin (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"currentColor","fillRule":"nonzero"},[React.createElement("path",{"d":"M8.331 15.11c1.145 1.146 2.24 2.245 3.372 3.382l1.75 1.76c.842-1.296.928-3.418.35-6.317l-.108-.539 6.82-5.051-2.708-2.687-2.752-2.79-5.032 6.839-.542-.11c-2.793-.56-4.922-.42-6.236.474.867.862 2.565 2.543 5.086 5.038zm7.273-.972c.66 3.697.3 6.401-1.533 8.031l-.61.542-.577-.575-2.41-2.422a2708.065 2708.065 0 0 0-3.365-3.377c-3.56-3.522-5.468-5.413-5.743-5.691l-.57-.576.537-.607c1.639-1.855 4.383-2.291 7.944-1.666L14.863.205l.713.723 3.458 3.507 4.133 4.101-7.563 5.602z","key":0}),React.createElement("path",{"d":"M1.39 23.273L.163 22.05 6.5 15.691l1.227 1.223z","key":1})]));
}

IconPin.defaultProps = {"width":"24","height":"24"};

module.exports = IconPin;

IconPin.default = IconPin;
